import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { TaskComment } from '../models/task';

export const TaskCommentFetch = createAction('[TaskComment] Fetch', props<{ workspaceId: string; taskId: string }>());
export const TaskCommentFetched = createAction(
  '[TaskComment] Fetched',
  props<{ taskComment: TaskComment[]; taskId: string }>()
);
export const TaskCommentError = createAction('[TaskComment] Error', props<{ taskId: string }>());

export const initialState: Record<string, CommonApiState<TaskComment[]>> = {};

export const taskCommentFeature = createFeature({
  name: 'taskComment',
  reducer: createReducer(
    initialState,
    on(TaskCommentFetch, (state, action) => ({
      ...state,
      [action.taskId]: {
        ...(state[action.taskId] ?? {}),
        currentPedingApis: (state[action.taskId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(TaskCommentFetched, (state, action) => {
      return {
        ...state,
        [action.taskId]: {
          ...(state[action.taskId] ?? {}),
          currentPedingApis: 0,
          data: action.taskComment
        }
      };
    }),
    on(TaskCommentError, (state, action) => {
      return {
        ...state,
        [action.taskId]: {
          ...(state[action.taskId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectTaskCommentState }) => {
    const taskCommentIsLoading = (taskId: string) =>
      createSelector(selectTaskCommentState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) > 0);

    const taskCommentHasPendingRequest = (taskId: string) =>
      createSelector(selectTaskCommentState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) >= 2);
    const taskCommentData = (taskId: string) => {
      return createSelector(selectTaskCommentState, taskCommentState => {
        return taskCommentState[taskId]?.data ?? [];
      });
    };

    return { taskCommentIsLoading, taskCommentHasPendingRequest, taskCommentData };
  }
});
